import $ from 'jquery';

class YoastFaq {
  constructor() {
    this.faqBlock = $('.wp-block-yoast-faq-block.is-accordion');

    if (!this.faqBlock.length) {
      return;
    }

    this.init();
  }

  init() {
    $.each(this.faqBlock, (i, el) => {
      const faq = $(el);
      const sections = faq.find('.schema-faq-section');
      const firstOpen = faq.hasClass('has-first-active');

      $.each(sections, (j, elem) => {
        const section = $(elem);
        const q = section.find('.schema-faq-question');
        const a = section.find('.schema-faq-answer');
        const aID = section.attr('id').replace('faq-question', '');

        q.attr('aria-expaned', false)
          .attr('aria-controls', `faq-answer${aID}`)
          .append('<span class="schema-faq-question-icon">+</span>');

        if (firstOpen && j === 0) {
          q.attr('aria-expaned', true);
          section.addClass('is-open');
          a.show();
        }
        a.attr('id', `faq-answer${aID}`);
      });
    });

    this.faqBlock.on('click', '.schema-faq-question', e => {
      const faq = $(e.delegateTarget);
      const q = $(e.currentTarget);
      const s = q.parent();
      const a = s.find('.schema-faq-answer');
      const icon = q.find('.schema-faq-question-icon');
      const closeOther = faq.hasClass('has-close-other');

      if (s.hasClass('is-open')) {
        a.slideUp();
        q.attr('aria-expaned', false);
        s.removeClass('is-open');
        icon.text('+');
      } else {
        if (closeOther) {
          faq
            .find('.schema-faq-section')
            .not(s)
            .removeClass('is-open');
          faq
            .find('.schema-faq-question')
            .not(q)
            .attr('aria-expaned', false);
          faq
            .find('.schema-faq-answer')
            .not(a)
            .slideUp();
          faq
            .find('.schema-faq-question-icon')
            .not(icon)
            .text('+');
        }

        a.slideDown();
        q.attr('aria-expaned', true);
        s.addClass('is-open');
        icon.text('-');
      }
    });
  }
}

export default new YoastFaq();



// WEBPACK FOOTER //
// ./src/scripts/modules/yoast-faq.js